import { logger } from '@sendpayments/js-utils';

export const reduce = (state, action) => {
  const { payload } = action;
  const { key } = payload || {};

  if (!payload) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/CREATE_ENTITY. payload need to be passed`, action);
  }

  if (!key) {
    logger.error('@sendpayments/react-shared/remote-data', `reducer/CLEAR_REMOTE_DATA. key need to be passed`, action);
  }

  const currentRemoteData = state[key];
  if (!currentRemoteData) {
    logger.error(
      '@sendpayments/react-shared/remote-data',
      `reducer/CLEAR_REMOTE_DATA. ${key} need to be initialized first.`,
      action,
    );
  }

  logger.log('@sendpayments/react-shared/remote-data', `reducer/CLEAR_REMOTE_DATA. ${key} has been cleared`, action);

  return {
    ...state,
    [key]: undefined,
  };
};
